import type { ColumnDef } from "@tanstack/react-table";
import { buildTagColumn } from "@/components/Table";
import type { TagType } from "@/components/Tag/Tag";
import { renderEmptyCellState } from "@/components/Table/utils";
import { toFormat } from "@/lib/dateHelpers";
import { formatEnumLabel } from "../../_utils";
import type { CommissionCampaignNode } from "../types";

function campaignStatusType(status: CommissionCampaignNode["status"]): TagType {
  if (status === "ACTIVE") return "success";
  if (status === "DRAFT") return "warn";
  return "surface";
}

export function getColumns(): ColumnDef<CommissionCampaignNode, unknown>[] {
  return [
    {
      accessorKey: "editionYear",
      header: "Edition year",
      size: 120,
      meta: { sortType: "numeric" }
    },
    {
      id: "partner",
      accessorFn: (row) => row.partner.name,
      header: "Partner",
      size: 200,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(row.original.partner.name)
    },
    {
      id: "program",
      accessorFn: (row) => row.program.name,
      header: "Program",
      size: 200,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(row.original.program.name)
    },
    buildTagColumn<CommissionCampaignNode>({
      accessorKey: "status",
      header: "Status",
      size: 120,
      getTagLabel: (row) => formatEnumLabel(row.status),
      getTagType: (row) => campaignStatusType(row.status),
      getTagStyle: () => "strong"
    }),
    {
      accessorKey: "payoutCadence",
      header: "Payout cadence",
      size: 140,
      enableSorting: false,
      cell: ({ row }) => formatEnumLabel(row.original.payoutCadence)
    },
    {
      accessorKey: "startsAt",
      header: "Starts",
      size: 120,
      meta: { sortType: "date" },
      cell: ({ row }) => toFormat(row.original.startsAt) || row.original.startsAt
    },
    {
      accessorKey: "endsAt",
      header: "Ends",
      size: 120,
      meta: { sortType: "date" },
      cell: ({ row }) => toFormat(row.original.endsAt) || row.original.endsAt
    }
  ];
}
